import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 内容管理接口
 */
export class PublicInterfaceInfoController {
    constructor() {
        this.baseurl = 'PublicInterfaceInfoController.assx/';
    }

    /**
     * 
     * token:String
     */
    getZFWToken(token){
        return request.post(this.baseurl + 'getZFWToken', Qs.stringify({ token:token }));
    }

    /**
     * 判断物业服务企业是否能在商事主体查询出数据
     * code:String
     */
    queryOrgInfoFromSSZT(code){
        return request.post(this.baseurl + 'queryOrgInfoFromSSZT', Qs.stringify({ code:code }));
    }

    /**
     * 
     * token:String, orgCode:String
     */
    getRealtyMgeComSSZT(token, orgCode){
        return request.post(this.baseurl + 'getRealtyMgeComSSZT', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取指定枚举所有映射值 。isDesc 是否倒序排列 
     * enumName:String, isDesc:boolean
     */
    getEnum(enumName, isDesc){
        return request.post(this.baseurl + 'getEnum', Qs.stringify({ enumName:enumName, isDesc:isDesc }));
    }

    /**
     * 调用核酸同步接口_开始时间到现在时间
     * begin:Date
     */
    insertEpidemicInfoSelectByBeginDate(begin){
        return request.post(this.baseurl + 'insertEpidemicInfoSelectByBeginDate', Qs.stringify({ begin:begin }));
    }

    /**
     * 
     * 
     */
    getImportProject(){
        return request.post(this.baseurl + 'getImportProject', Qs.stringify({  }));
    }

    /**
     * 获取业委会数据共享信息
     * ownerTeamCode:String, unifiedSocialCreditCode:String, ownerTeamName:String, eaAreaName:String, startIndex:int, maxSize:int, accessToken:String, startTime:String, endTime:String
     */
    getOwnerTeamEntVOList(ownerTeamCode, unifiedSocialCreditCode, ownerTeamName, eaAreaName, startIndex, maxSize, accessToken, startTime, endTime){
        return request.post(this.baseurl + 'getOwnerTeamEntVOList', Qs.stringify({ ownerTeamCode:ownerTeamCode, unifiedSocialCreditCode:unifiedSocialCreditCode, ownerTeamName:ownerTeamName, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken, startTime:startTime, endTime:endTime }));
    }

    /**
     * 通过名称查询 机构列表 
     * orgName:String, orgType:int, startIndex:int, size:int
     */
    getOrgInfoList(orgName, orgType, startIndex, size){
        return request.post(this.baseurl + 'getOrgInfoList', Qs.stringify({ orgName:orgName, orgType:orgType, startIndex:startIndex, size:size }));
    }

    /**
     * 
     * title:String, startTime:String, endTime:String, startIndex:int, maxSize:int, accessToken:String
     */
    getPublicInfoExternalVoList(title, startTime, endTime, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getPublicInfoExternalVoList', Qs.stringify({ title:title, startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 主动触发同步备案数据
     * code:String
     */
    runUpdateReocrd(code){
        return request.post(this.baseurl + 'runUpdateReocrd', Qs.stringify({ code:code }));
    }

    /**
     * 验证人员是否存在接口
     * type:int, queryInfo:String
     */
    ProUnionCheck(type, queryInfo){
        return request.post(this.baseurl + 'ProUnionCheck', Qs.stringify({ type:type, queryInfo:queryInfo }));
    }

    /**
     * 通用apo 调用核酸调用接口 
     * data:String
     */
    getRemoteHeSuanDataById(data){
        return request.post(this.baseurl + 'getRemoteHeSuanDataById', Qs.stringify({ data:data }));
    }

    /**
     * 
     * orgName:String, orgCode:String, name:String, sex:int, startIndex:int, maxSize:int, accessToken:String
     */
    getRealtyMngOrgPersonExternalVoList(orgName, orgCode, name, sex, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getRealtyMngOrgPersonExternalVoList', Qs.stringify({ orgName:orgName, orgCode:orgCode, name:name, sex:sex, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 根据维修资金物业项目代码判断小区是否签约共有资金账户
     * hmfsEaAreaCode:String
     */
    isRegistBankAccount(hmfsEaAreaCode){
        return request.post(this.baseurl + 'isRegistBankAccount', Qs.stringify({ hmfsEaAreaCode:hmfsEaAreaCode }));
    }

    /**
     * 查询业委会成员详细信息 
     * memberKeyId:String
     */
    getOwnerMemberDetail(memberKeyId){
        return request.post(this.baseurl + 'getOwnerMemberDetail', Qs.stringify({ memberKeyId:memberKeyId }));
    }

    /**
     * 获取区划下的镇或者街道办
     * code:String, provinceCode:String, cityCode:String, areaCode:String, startIndex:int, maxSize:int
     */
    getTownOrStreetOfArea(code, provinceCode, cityCode, areaCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getTownOrStreetOfArea', Qs.stringify({ code:code, provinceCode:provinceCode, cityCode:cityCode, areaCode:areaCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取大额资金转账公示数据共享信息
     * gsbh:String, eaAreaName:String, startIndex:int, maxSize:int, accessToken:String, startTime:String, endTime:String
     */
    getLargeMoneyNoticeEntVOList(gsbh, eaAreaName, startIndex, maxSize, accessToken, startTime, endTime){
        return request.post(this.baseurl + 'getLargeMoneyNoticeEntVOList', Qs.stringify({ gsbh:gsbh, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken, startTime:startTime, endTime:endTime }));
    }

    /**
     * 调用核酸同步接口
     * begin:Date, end:Date
     */
    insertEpidemicInfoSelectByDateRange(begin, end){
        return request.post(this.baseurl + 'insertEpidemicInfoSelectByDateRange', Qs.stringify({ begin:begin, end:end }));
    }

    /**
     * 
     * orgName:String, orgCode:String, startTime:String, endTime:String, startIndex:int, maxSize:int, accessToken:String
     */
    getRealtyMngOrgExternalVoList(orgName, orgCode, startTime, endTime, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getRealtyMngOrgExternalVoList', Qs.stringify({ orgName:orgName, orgCode:orgCode, startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 测试方法
     * startTime:String, endTime:String
     */
    testPublicInfos(startTime, endTime){
        return request.post(this.baseurl + 'testPublicInfos', Qs.stringify({ startTime:startTime, endTime:endTime }));
    }

    /**
     * 查询准确的省市区
     * code:String, child:boolean
     */
    getProvinceDetail(code, child){
        return request.post(this.baseurl + 'getProvinceDetail', Qs.stringify({ code:code, child:child }));
    }

    /**
     * 通用api 调用核酸采集接口
     * idCard:String
     */
    getRemoteHeSuanData(idCard){
        return request.post(this.baseurl + 'getRemoteHeSuanData', Qs.stringify({ idCard:idCard }));
    }

    /**
     * 验证code 是否正确
     * code:String, userType:String, orgName:String
     */
    CheckUserInfoByCodeTest(code, userType, orgName){
        return request.post(this.baseurl + 'CheckUserInfoByCodeTest', Qs.stringify({ code:code, userType:userType, orgName:orgName }));
    }
    /**
     * 验证code 是否正确
     * code:String, userType:String, orgName:String
     */
    CheckUserInfoByCodeFromZhzj(code, userType, orgName){
        return request.post(this.baseurl + 'CheckUserInfoByCodeFromZhzj', Qs.stringify({ code:code, userType:userType, orgName:orgName }));
    }
    /**
     * 调用redis数据存库
     * 
     */
    getRedisDataToSaveDataBase(){
        return request.post(this.baseurl + 'getRedisDataToSaveDataBase', Qs.stringify({  }));
    }

    /**
     * 
     * startTime:String, endTime:String, startIndex:int, maxSize:int, accessToken:String
     */
    getWeChatNoticeExternalVoList(startTime, endTime, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getWeChatNoticeExternalVoList', Qs.stringify({ startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 通过宗地号 查询 物业区域信息 
     * landNumber:String, eaAreaCode:String
     */
    getEaAreaDetail(landNumber, eaAreaCode){
        return request.post(this.baseurl + 'getEaAreaDetail', Qs.stringify({ landNumber:landNumber, eaAreaCode:eaAreaCode }));
    }

    /**
     * 通过街道办名称查询 下面的居委会（社区） 
     * streetName:String, startIndex:int, size:int
     */
    getResidentsCommitteeListFromStreetName(streetName, startIndex, size){
        return request.post(this.baseurl + 'getResidentsCommitteeListFromStreetName', Qs.stringify({ streetName:streetName, startIndex:startIndex, size:size }));
    }

    /**
     * 获取物业项目人员数据共享信息
     * personName:String, eaAreaName:String, startIndex:int, maxSize:int, accessToken:String, startTime:String, endTime:String
     */
    getEaAreaEmployeeEntVOList(personName, eaAreaName, startIndex, maxSize, accessToken, startTime, endTime){
        return request.post(this.baseurl + 'getEaAreaEmployeeEntVOList', Qs.stringify({ personName:personName, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken, startTime:startTime, endTime:endTime }));
    }

    /**
     * 修改物业企业信息
     * orgCode:String, startIndex:int, maxSize:int
     */
    modifyOrgInfo(orgCode, startIndex, maxSize){
        return request.post(this.baseurl + 'modifyOrgInfo', Qs.stringify({ orgCode:orgCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取所有省
     * keyName:String, valueName:String, startIndex:int, maxSize:int
     */
    GetAllProvince(keyName, valueName, startIndex, maxSize){
        return request.post(this.baseurl + 'GetAllProvince', Qs.stringify({ keyName:keyName, valueName:valueName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通用api 调用疫苗采集接口
     * 
     */
    getRemoteYIMIAOData(){
        return request.post(this.baseurl + 'getRemoteYIMIAOData', Qs.stringify({  }));
    }

    /**
     * 
     * bindDate:String
     */
    inserHmfsOwnerHouse(bindDate){
        return request.post(this.baseurl + 'inserHmfsOwnerHouse', Qs.stringify({ bindDate:bindDate }));
    }

    /**
     * 通过街道办名称查询 下面的居委会（社区） 
     * orgCode:String, startIndex:int, size:int
     */
    getOwnerMemberListByOrgCode(orgCode, startIndex, size){
        return request.post(this.baseurl + 'getOwnerMemberListByOrgCode', Qs.stringify({ orgCode:orgCode, startIndex:startIndex, size:size }));
    }

    /**
     * 获取指定枚举所有映射值 的 分页。isDesc 是否倒序排列 
     * enumName:String, isDesc:boolean, startIndex:int, maxSize:int
     */
    getEnumPage(enumName, isDesc, startIndex, maxSize){
        return request.post(this.baseurl + 'getEnumPage', Qs.stringify({ enumName:enumName, isDesc:isDesc, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * eaAreaName:String, startTime:String, endTime:String, startIndex:int, maxSize:int, accessToken:String
     */
    getEaAreaExternalVoList(eaAreaName, startTime, endTime, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getEaAreaExternalVoList', Qs.stringify({ eaAreaName:eaAreaName, startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 通过名称查询 物业区域列表 
     * eaAreaName:String, startIndex:int, size:int
     */
    getEaAreaList(eaAreaName, startIndex, size){
        return request.post(this.baseurl + 'getEaAreaList', Qs.stringify({ eaAreaName:eaAreaName, startIndex:startIndex, size:size }));
    }

    /**
     * 
     * 
     */
    getRemoteReport(){
        return request.post(this.baseurl + 'getRemoteReport', Qs.stringify({  }));
    }

    /**
     * 获取银行流水
     * accountCode:String, startTime:String, endTime:String
     */
    getCommonAccountTransList(accountCode, startTime, endTime){
        return request.post(this.baseurl + 'getCommonAccountTransList', Qs.stringify({ accountCode:accountCode, startTime:startTime, endTime:endTime }));
    }

    /**
     * 获取业委会成员数据共享信息
     * ownerName:String, eaAreaName:String, ownerTeamName:String, startIndex:int, maxSize:int, accessToken:String, startTime:String, endTime:String
     */
    getOwnerTeamMemberEntVOList(ownerName, eaAreaName, ownerTeamName, startIndex, maxSize, accessToken, startTime, endTime){
        return request.post(this.baseurl + 'getOwnerTeamMemberEntVOList', Qs.stringify({ ownerName:ownerName, eaAreaName:eaAreaName, ownerTeamName:ownerTeamName, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken, startTime:startTime, endTime:endTime }));
    }

    /**
     * 验证code 是否正确
     * code:String, userType:String
     */
    CheckUserInfoByCode(code, userType){
        return request.post(this.baseurl + 'CheckUserInfoByCode', Qs.stringify({ code:code, userType:userType }));
    }

    /**
     * 
     * title:String, startTime:String, endTime:String, startIndex:int, maxSize:int, accessToken:String
     */
    getSecurityCheckExternalVoList(title, startTime, endTime, startIndex, maxSize, accessToken){
        return request.post(this.baseurl + 'getSecurityCheckExternalVoList', Qs.stringify({ title:title, startTime:startTime, endTime:endTime, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken }));
    }

    /**
     * 获取市下的区划
     * code:String, provinceCode:String, cityCode:String, startIndex:int, maxSize:int
     */
    getAreaOfCity(code, provinceCode, cityCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getAreaOfCity', Qs.stringify({ code:code, provinceCode:provinceCode, cityCode:cityCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 通用数据库调用核酸采集接口
     * 
     */
    getHeSuanData(){
        return request.post(this.baseurl + 'getHeSuanData', Qs.stringify({  }));
    }
/**
     * 通过街道办代码查询 下面的居委会（社区）给发布居代业公告 
     * streetCode:String, startIndex:int, size:int
     */
getResidentsCommitteeListFromStreetCodeForJDY(streetCode, startIndex, size){
    return request.post(this.baseurl + 'getResidentsCommitteeListFromStreetCodeForJDY', Qs.stringify({ streetCode:streetCode, startIndex:startIndex, size:size }));
}

    /**
     * 通过街道办代码查询 下面的居委会（社区） 
     * streetCode:String, startIndex:int, size:int
     */
    getResidentsCommitteeListFromStreetCode(streetCode, startIndex, size){
        return request.post(this.baseurl + 'getResidentsCommitteeListFromStreetCode', Qs.stringify({ streetCode:streetCode, startIndex:startIndex, size:size }));
    }
  /**
     * 通过行政区和街道办名称查询 下面的居委会（社区） 
     * cantonName:String, streetName:String, startIndex:int, size:int
     */
  getResidentsCommitteeListFromCantonNameAndStreetName(cantonName, streetName, startIndex, size){
    return request.post(this.baseurl + 'getResidentsCommitteeListFromCantonNameAndStreetName', Qs.stringify({ cantonName:cantonName, streetName:streetName, startIndex:startIndex, size:size }));
}
    /**
     * 获取指定枚举所有映射值 自定义键值对名称
     * 注：提供的枚举名称是含包名的全称
     *  内部类的枚举，名称类型如： ps.core.commons.EnumDefines$ETossWay
     * @param enumName
     * @param isDesc 是否倒序排列
     * @param keyName 返回键值对 key名称 默认为 label
     * @param valueName 返回键值对 value 名称 默认为 value
     * enumName:String, isDesc:boolean, keyName:String, valueName:String
     */
    getEnumDefineBySelf(enumName, isDesc, keyName, valueName){
        return request.post(this.baseurl + 'getEnumDefineBySelf', Qs.stringify({ enumName:enumName, isDesc:isDesc, keyName:keyName, valueName:valueName }));
    }

    /**
     * 判断企业是否是首次登录
     * code:String
     */
    queryOrgFirstLoginByCode(code){
        return request.post(this.baseurl + 'queryOrgFirstLoginByCode', Qs.stringify({ code:code }));
    }

    /**
     * 
     * areaName:String, areaCode:String, streetName:String, streetCode:String, areaCodeList:List, cantonCode:String, cantonName:String, pageIndex:int, pageSize:int, isPage:boolean, streetCodeGB:String, cantonCodeGB:String
     */
    queryAreaData(areaName, areaCode, streetName, streetCode, areaCodeList, cantonCode, cantonName, pageIndex, pageSize, isPage, streetCodeGB, cantonCodeGB){
        return request.post(this.baseurl + 'queryAreaData', Qs.stringify({ areaName:areaName, areaCode:areaCode, streetName:streetName, streetCode:streetCode, areaCodeList:areaCodeList, cantonCode:cantonCode, cantonName:cantonName, pageIndex:pageIndex, pageSize:pageSize, isPage:isPage, streetCodeGB:streetCodeGB, cantonCodeGB:cantonCodeGB }));
    }

    /**
     * 通过机构 统一社会信用代码查询机构信息
     * orgCode:String, orgType:int
     */
    getOrgInfoDetail(orgCode, orgType){
        return request.post(this.baseurl + 'getOrgInfoDetail', Qs.stringify({ orgCode:orgCode, orgType:orgType }));
    }

    /**
     * 根据社区编码获取项目信息
     * sectionCode:String, startIndex:int, maxSize:int
     */
    getEaAreaListByStationCode(sectionCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getEaAreaListByStationCode', Qs.stringify({ sectionCode:sectionCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取共有资金账户数据共享信息
     * eaAreaName:String, zh:String, startIndex:int, maxSize:int, accessToken:String, startTime:String, endTime:String
     */
    getCommonAccountEntVOList(eaAreaName, zh, startIndex, maxSize, accessToken, startTime, endTime){
        return request.post(this.baseurl + 'getCommonAccountEntVOList', Qs.stringify({ eaAreaName:eaAreaName, zh:zh, startIndex:startIndex, maxSize:maxSize, accessToken:accessToken, startTime:startTime, endTime:endTime }));
    }

    /**
     * 获取省下的市
     * code:String, provinceCode:String, startIndex:int, maxSize:int
     */
    getCityOfProvince(code, provinceCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getCityOfProvince', Qs.stringify({ code:code, provinceCode:provinceCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String
     */
    getToken(token){
        return request.post(this.baseurl + 'getToken', Qs.stringify({ token:token }));
    }

    /**
     * 
     * token:String
     */
    getMatchToken(token){
        return request.post(this.baseurl + 'getMatchToken', Qs.stringify({ token:token }));
    }
}